export enum EpisodeContentState {
  IDLE,
  UPLOADING,
  UPLOADED,
  PROCESSING,
  SINGLE_FILE,
  MULTI_FILE,
  ERROR,
}
